module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMABQkMFRcZJyosLj9HZW1wc4STlZqfoN7j5Oz2+v3rh6CmAAAAmUlEQVRIx+3WyQ6CMBRA0cooU2VGgd7//0x2JqYt+BLjqnfZcNKUzXtKvYtr/XCm61g5ql54e1b29+nKSWtqAQ1DeXdWDqAtMGIi5SkyjNbhxK687UwBBBBAAAH8AcyYwZtx3nDaD8DMfvN2/eii7wvJX8o32HIB6AA6AWgBWgHIFliyc/A5dpOmSS7Grniwi1cH8XLy7fpzAOIbNxsvIcBsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneIcon.png
// module id = FZo/
// module chunks = 1